import React from 'react';
import { isCapabilityEnabled } from 'owa-capabilities';
import { bleedThroughCapability } from 'owa-capabilities-definitions/lib/bleedThroughCapability';
import { copilotThemeCapability } from 'owa-capabilities-definitions/lib/copilotThemeCapability';
import classnames from 'owa-classnames';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { observer } from 'owa-mobx-react';
import {
    backgroundImage,
    backgroundGradient,
    copilotBackgroundGradient,
    copilotDarkBackground,
} from './AppBackground.scss';
import getBackgroundImage from '../selectors/getBackgroundImage';
import getBackgroundColor from '../selectors/getBackgroundColor';

const AppBackground: React.FunctionComponent = observer(function AppBackground() {
    const image = getBackgroundImage();
    const isDarkTheme = getIsDarkTheme();
    const backgroundColor = getBackgroundColor();
    const isCopilotThemeEnabled = isCapabilityEnabled(copilotThemeCapability);
    const isBleedThroughEnabled = isCapabilityEnabled(bleedThroughCapability);

    const backgroundImageStyles = React.useMemo(() => {
        return {
            backgroundColor,
            backgroundImage: image ? `url(${image})` : 'none',
        };
    }, [image]);

    return isBleedThroughEnabled ? (
        <div
            className={classnames(
                isCopilotThemeEnabled ? copilotBackgroundGradient : backgroundGradient
            )}
        >
            <div
                style={backgroundImageStyles}
                className={classnames(
                    backgroundImage,
                    isCopilotThemeEnabled && isDarkTheme && copilotDarkBackground
                )}
            />
        </div>
    ) : null;
}, 'AppBackground');

export default AppBackground;
